module.exports = __webpack_public_path__ + "media/images/slider_h1_05-c91ba902b1108ff596f63e32bbde21ea.png";